import React from 'react';

export const ComplianceCheckContext = React.createContext<{
  complianceCheckId: string;
  sanctionsCheckId: string;
} | null>(null);
